import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPageState } from '../../types/pageState/pageState';

const initialState: IPageState = {
  animationAvailable: true,
};

export const pageStateSlice = createSlice({
  name: 'pageState',
  initialState,
  reducers: {
    setAnimationAvailable: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        animationAvailable: action.payload,
      };
    },
  },
});

export const {
  reducer: pageStateReducer,
  actions: { setAnimationAvailable },
} = pageStateSlice;
